import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import { useTheme } from "@mui/material";

function isFirstColumn(params) {
    var displayedColumns = params?.columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn = displayedColumns && (displayedColumns[0] === params?.column);
    return thisIsFirstColumn;
}

const AgGridTable = ({ rowData, columnDefs, rowClassRules, onRowSelected, columnTypes, onSelectionChanged, editable, rowSelection, tableClassName, enableRowGroup ,
    suppressClickEdit, hideCheckbox, onRowDoubleClicked, getContextMenuItems, onCellEditingStopped, onCellValueChanged, onGridReady, gridRef, paginationPageSize, cacheBlockSize,
    rowModelType, isRowSelectable, showDisabledCheckboxes, suppressAggFuncInHeader, rowGroupPanelShow, showSidebar, floatingFilter, loadingOverlayComponent,
    onFirstDataRendered, rowMultiSelectWithClick, masterDetail, detailCellRendererParams, isRowMaster, pagination, onRowDataUpdated, groupDisplayType,
    cellStyle, groupCheckBox = false, rowHeight, autoGroupField, editType, onRowValueChanged, rowDragManaged, saveGridStateName, groupRowRendererParams,
    onColumnRowGroupChanged, wrapHeaderText, autoHeaderHeight, headerHeight, getFilterValue, onCellKeyDown, suppressRowTransform, suppressRowCount, columnFilter,
    filterValueGetter, onRowGroupOpened, groupRowMinWidth, groupDefaultExpanded, getRowStyle, groupAllowUnbalanced = false, onResetColumnState,groupSearchColumn
    ,gridTheme,statusBar,onCellClicked, detailRowHeight,groupIncludeFooter,singleClickEdit,suppressRowClickSelection,groupIncludeTotalFooter,paginationNotAutoPageSize, suppressContextMenu, onSortRefresh, getGroupRowAgg ,getRowId,context,onRowClicked, processCellFromClipboard, onPasteEnd}) => {
    const stateRef = useRef();
    const theme = useTheme()
    const [stateData, setStateData] = useState({ filter: '', columnState: '', columnGroupState: '' });
    const gridStateId = useRef();
    const isInitialLoad = useRef(true);
    const sideBar = useMemo(() => ({
    toolPanels: [
        {
            id: 'columns',
            labelDefault: 'Columns',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
        },
        {
            id: 'filters',
            labelDefault: 'Filters',
            labelKey: 'filters',
            iconKey: 'filter',
            toolPanel: 'agFiltersToolPanel',
        },
    ],
}), []);
    const defaultColDef = useMemo((params) => {
        return {
            flex: 1,
            // minWidth: 100,
            sortable: true,
            resizable: true,
            filter: 'agMultiColumnFilter',
            floatingFilter: (floatingFilter === false) ? false : true,
            domLayout: 'autoHeight',
            wrapHeaderText: wrapHeaderText,
            autoHeaderHeight: autoHeaderHeight,
            showDisabledCheckboxes: showDisabledCheckboxes,
            editable: (editable === false) ? false : true,
            tooltipShowDelay: 0,
            enableRowGroup:enableRowGroup,
            filterParams: {
                filters: [
                    {
                        filter: 'agTextColumnFilter',
                        filterParams: { buttons: ['clear'] },
                    },
                    {
                        filter: 'agSetColumnFilter',
                        filterParams: { defaultToNothingSelected: true, buttons: ['clear'] },
                    },
                ]
            },
            headerCheckboxSelection: hideCheckbox ? false : isFirstColumn,
            checkboxSelection: hideCheckbox ? false : isFirstColumn,
            cellStyle: cellStyle ? { borderRight: '1px solid #757575' } : ""
        };
    }, [floatingFilter]);

    const groupColumnsData = (params) => {
        let allData = '';
        params.columnApi.getRowGroupColumns().map((col) => {
            allData = allData + ` ${params.data[col.colId] || ''} `;
            return col.colId;
        });
        return allData;
    }


    const autoGroupColumnDef = useMemo(() => {
        return {
            minWidth: groupRowMinWidth,
            cellRendererParams: {
                suppressCount: suppressRowCount ? suppressRowCount : false,
                checkbox: groupCheckBox === false ? false : true,
            },
            field: autoGroupField,
            // filter: columnFilter,
            filter: columnFilter,
            filterValueGetter: (params) => groupSearchColumn ? groupSearchColumn(params) : groupColumnsData(params)
        };
    }, []);

const onFilterChanged = (params) => {
    if (isInitialLoad.current) return;

    setStateData(prev => ({
        ...prev,
        filter: params?.api?.getFilterModel()
    }));
};

const onColumnStateChanged = (params) => {
    if (isInitialLoad.current) return;

    setStateData(prev => ({
        ...prev,
        columnState: params?.columnApi?.getColumnState(),
        columnGroupState: params?.columnApi?.getColumnGroupState()
    }));
};

const onColumnGroupChange = (params) => {
    onColumnRowGroupChanged && onColumnRowGroupChanged(params);
    onColumnStateChanged(params);
};
const onFirstDataLoad = (params) => {
    onFirstDataRendered && onFirstDataRendered();

    if (!saveGridStateName) return;

    const savedState = localStorage.getItem(saveGridStateName);

    if (savedState) {
        try {
            const parsedState = JSON.parse(savedState);

            setTimeout(() => {
                if (parsedState.filter) {
                    params.api.setFilterModel(parsedState.filter);
                }

                if (parsedState.columnState) {
                    params.columnApi.applyColumnState({
                        state: parsedState.columnState,
                        applyOrder: true
                    });
                }

                if (parsedState.columnGroupState) {
                    params.columnApi.setColumnGroupState(
                        parsedState.columnGroupState
                    );
                }

                isInitialLoad.current = false;

            }, 100); 

        } catch (err) {
            console.error("Failed to parse grid state:", err);
            isInitialLoad.current = false;
        }
    } else {
        isInitialLoad.current = false;
    }
};
useEffect(() => {
    if (!saveGridStateName) return;
    if (isInitialLoad.current) return; 

    const timeout = setTimeout(() => {
        localStorage.setItem(
            saveGridStateName,
            JSON.stringify(stateData)
        );
    }, 300);

    return () => clearTimeout(timeout);
}, [stateData, saveGridStateName]);
    // useEffect(() => {
    //     if (saveGridStateName) {
    //         const saveState = {
    //             screenName: saveGridStateName,
    //             screenState: stateData
    //         }
    //         stateRef.current = saveState;
    //     }
    // }, [stateData])

    // const onFilterChanged = (params) => {
    //     stateData.filter = params?.api?.getFilterModel();
    //     setStateData(stateData)
    // }

    // const onColumnStateChanged = (params) => {
    //     // onSortRefresh(params);
    //     stateData.columnState = params?.columnApi?.getColumnState();
    //     stateData.columnGroupState = params?.columnApi?.getColumnGroupState();
    // }
    // const onColumnGroupChange = (params) => {
    //     onColumnRowGroupChanged && onColumnRowGroupChanged(params);
    //     onColumnStateChanged(params);
    // }
    // const onFirstDataLoad = async (params) => {
    //     onFirstDataRendered && onFirstDataRendered();
    //     if (saveGridStateName) {
    //         const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.gridState}`;
    //         const savedState = await OAuthService.getList(url + '/fetchState?screenName=' + saveGridStateName);
    //         const data = savedState?.data;

    //         if (data) {
    //             gridStateId.current = data?.id;
    //             data.screenState.filter && params.api.setFilterModel(data?.screenState.filter);
    //             data.screenState.columnState && params.columnApi.applyColumnState({ state: data?.screenState?.columnState, applyOrder: true });
    //             data.screenState.columnGroupState && params.columnApi.setColumnGroupState(data?.screenState?.columnGroupState);
    //         }
    //     }
    // }

    // useEffect(() => {
    //     const unloadCallback = () => {
    //         if (saveGridStateName) {
    //             const gridState = async () => {
    //                 if (gridStateId.current) {
    //                     try {
    //                         const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.gridStates}`;
    //                         const saveState = await OAuthService.updateData(url, gridStateId.current, stateRef.current);
    //                     } catch (error) {
    //                         console.log(error);
    //                     }
    //                 } else {
    //                     try {
    //                         const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.gridState}`;
    //                         const saveState = await OAuthService.addData(url + '/saveState', stateRef.current);
    //                     } catch (error) {
    //                         console.log(error);
    //                     }
    //                 }
    //             }
    //             gridState();
    //         }
    //     }
    //     window.addEventListener("beforeunload", unloadCallback);
    //     return () => {
    //         window.removeEventListener("beforeunload", unloadCallback);
    //         unloadCallback();
    //     }
    // }, []);

    return (
        <div className={(gridTheme ? gridTheme : theme?.palette?.mode === 'dark' ? 'ag-theme-alpine-dark grid ' : 'ag-theme-alpine grid ') + tableClassName} style={{ height: '100%', width: '100%' }}>
            <AgGridReact
                ref={gridRef}
                rowData={rowData}
                getContextMenuItems={getContextMenuItems}
                columnDefs={columnDefs}
                getGroupRowAgg= {getGroupRowAgg}
                defaultColDef={defaultColDef}
                autoGroupColumnDef={autoGroupColumnDef}
                animateRows={true}
                style={{ height: '100%', width: '100%' }}
                suppressAggFuncInHeader={suppressAggFuncInHeader}
                 singleClickEdit={singleClickEdit?true:false}
                // groupSelectsChildren={true}
                isRowSelectable={isRowSelectable}
                onRowSelected={onRowSelected}
                rowGroupPanelShow={rowGroupPanelShow || 'always'}
                groupDisplayType={groupDisplayType || 'singleColumn'}
                columnTypes={columnTypes}
                sideBar={(showSidebar === false) ? false : sideBar}
                onSelectionChanged={onSelectionChanged}
                onRowDoubleClicked={onRowDoubleClicked}
                rowSelection={rowSelection || 'multiple'}
                onGridReady={onGridReady}
                suppressRowTransform={suppressRowTransform}
                paginationAutoPageSize={paginationNotAutoPageSize ? false : true}
                onRowClicked={onRowClicked}
                pagination={false}
                onCellValueChanged={onCellValueChanged}
                onCellEditingStopped={onCellEditingStopped}
                rowModelType={rowModelType}
                // onPaginationChanged={onPaginationChanged }
                paginationPageSize={paginationPageSize || paginationNotAutoPageSize}
                cacheBlockSize={cacheBlockSize}
                enableCellChangeFlash={true}
                rowClassRules={rowClassRules}
                suppressClickEdit={suppressClickEdit}
                enableCharts={true}
                groupRowRendererParams={groupRowRendererParams}
                loadingOverlayComponent={loadingOverlayComponent}
                enableRangeSelection={true}
                masterDetail={masterDetail}
                detailCellRendererParams={detailCellRendererParams}
                isRowMaster={isRowMaster}
                onFirstDataRendered={onFirstDataLoad}
                rowMultiSelectWithClick={rowMultiSelectWithClick}
                onRowDataUpdated={onRowDataUpdated}
                getRowId={getRowId}
                suppressDragLeaveHidesColumns={true}
                // rowHeight={rowHeight}
                editType={editType}
                onRowValueChanged={onRowValueChanged}
                rowDragManaged={rowDragManaged}
                getRowStyle={getRowStyle}
                detailRowHeight={detailRowHeight ? detailRowHeight : 600}
                onFilterChanged={onFilterChanged}
                groupAllowUnbalanced={groupAllowUnbalanced}
                onSortChanged={onColumnStateChanged}
                onColumnVisible={onColumnStateChanged}
                onColumnPinned={onColumnStateChanged}
                suppressContextMenu={suppressContextMenu}
                onColumnResized={onColumnStateChanged}
                onColumnMoved={onColumnStateChanged}
                onColumnRowGroupChanged={onColumnGroupChange}
                onCellKeyDown={onCellKeyDown}
                groupDefaultExpanded={groupDefaultExpanded}
                onRowGroupOpened={onRowGroupOpened}
                statusBar={statusBar}
                headerHeight={28}
                context={context}
                rowHeight={rowHeight?rowHeight:22}
                groupIncludeFooter={groupIncludeFooter}
                tooltipShowDelay={0}
                tooltipHideDelay={2000}
                cellSelection={true}
                groupIncludeTotalFooter={groupIncludeTotalFooter}
                suppressRowClickSelection={suppressRowClickSelection?suppressRowClickSelection:false}
                onCellClicked={onCellClicked}
                processCellFromClipboard={processCellFromClipboard}
                onPasteEnd={onPasteEnd}
            ></AgGridReact>
        </div>
    )
}

export default AgGridTable;